import { useEffect, useState } from 'react'

const PC_QUERY = '(min-width: 768px)'

export function useIsPc(): boolean {
  const [isPc, setIsPc] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(PC_QUERY).matches,
  )

  useEffect(() => {
    const query = window.matchMedia(PC_QUERY)
    const sync = () => setIsPc(query.matches)
    sync()
    query.addEventListener('change', sync)
    return () => query.removeEventListener('change', sync)
  }, [])

  return isPc
}
